import { toDate } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { ref } from 'vue';
import { t } from '@/utils/i18n';

const locTimeZone = ref('Asia/Shanghai');

/**
 * Set global timezone to use by conversion functions
 * @param tz Timezone to set
 */
export function setTimezone(tz: string) {
  locTimeZone.value = tz;
}

export function getTimeZone(tz?: string): string {
  return tz || locTimeZone.value;
}

export function formatDate(date: Date, formatPattern: string, timezone?: string): string {
  return formatInTimeZone(date, getTimeZone(timezone), formatPattern);
}

export function timeZoneLabel(timezone = getTimeZone()): string {
  return timezone === 'Asia/Shanghai' ? t('Beijing time (UTC+8)') : timezone;
}

function chartDate(value: number | string | Date): Date {
  if (value instanceof Date) return value;
  return new Date(typeof value === 'string' && /^\d+$/.test(value) ? Number(value) : value);
}

export function chartTimeLabel(value: number | string | Date): string {
  const date = chartDate(value);
  return `${formatDate(date, 'MM-dd')}\n${formatDate(date, 'HH:mm')}`;
}

export function chartTimePointer(params: { value: number | string | Date }): string {
  return timestampmsWithTimezone(chartDate(params.value));
}

/** Format an instant using the console's display timezone. */
export function timestampms(ts: number | Date): string {
  return formatDate(toDate(ts), 'yyyy-MM-dd HH:mm:ss');
}

/**
 * Convert a timestamp / Date object to String
 * @param ts Timestamp as number or date (in utc!!)
 * @param timezone timezone to use
 * @returns formatted date in desired timezone (or globally configured timezone)
 */
export function timestampmsWithTimezone(ts: number | Date | null, timezone?: string): string {
  if (!ts) {
    return 'N/A';
  }
  return formatDate(toDate(ts), 'yyyy-MM-dd HH:mm:ss (z)', timezone);
}
